module.exports = __webpack_public_path__ + "e58643778f9253ca21aeef542576ab4a.png";